'use es6';

import I18n from 'I18n';
import { getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
export const getEditorsDisabledMessage = threadDetails => {
  if (getIsSoftDeleted(threadDetails)) return I18n.text('conversations-thread-view.tabbed-editors.disabledReasons.threadDeleted');
  return null;
};